// Shared helpers for the admin panels (Blog, Media, Page Content).

// Normalize an axios/FastAPI error into a single human-readable string.
// FastAPI returns 422 with `detail` as an array of error objects — rendering
// that directly in JSX would throw "Objects are not valid as a React child".
export const extractErrorMessage = (err, fallback) => {
    const detail = err?.response?.data?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail) && detail.length > 0) {
        return detail
            .map((d) => {
                const path = Array.isArray(d?.loc)
                    ? d.loc.filter((seg) => seg !== "body").join(".")
                    : "";
                const msg = d?.msg || "Invalid value";
                return path ? `${path}: ${msg}` : msg;
            })
            .join("; ");
    }
    if (detail && typeof detail === "object") {
        return detail.msg || JSON.stringify(detail);
    }
    return err?.message || fallback || "Something went wrong.";
};

export const toCsv = (arr) => (Array.isArray(arr) ? arr.join(", ") : "");

export const fromCsv = (str) =>
    String(str || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);

export const formatBytes = (n) => {
    const b = Number(n) || 0;
    if (b < 1024) return `${b} B`;
    if (b < 1024 * 1024) return `${(b / 1024).toFixed(0)} KB`;
    return `${(b / (1024 * 1024)).toFixed(1)} MB`;
};
